import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import "./App.css";
import { AuthProvider } from "./lib/auth";
import { SettingsProvider } from "./lib/settings";
import { CartProvider } from "./lib/cart";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import About from "./pages/About";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import OrderLookup from "./pages/OrderLookup";
import OrderSuccess from "./pages/OrderSuccess";
import Wishlist from "./pages/Wishlist";
import Account from "./pages/Account";
import Info from "./pages/Info";
import SEOHead from "./components/SEOHead";
import AnnouncementBanner from "./components/AnnouncementBanner";
import PromoBanner from "./components/PromoBanner";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Shell() {
  return (
    <>
      <ScrollToTop />
      <SEOHead />
      <AnnouncementBanner />
      <Header />
      <PromoBanner />
      <CartDrawer />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/orders" element={<OrderLookup />} />
          <Route path="/order/success" element={<OrderSuccess />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/account" element={<Account />} />
          <Route path="/info/:slug" element={<Info />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App bg-[#FDFBF7] text-[#2C2924]">
      <BrowserRouter>
        <SettingsProvider>
          <AuthProvider>
            <CartProvider>
              <Shell />
              <Toaster position="top-center" />
            </CartProvider>
          </AuthProvider>
        </SettingsProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
